import { Box, Button, Layer, Text } from 'grommet';

export interface IConfirmModalProps {
  content: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmModal = ({ content, confirmLabel, cancelLabel, onConfirm, onCancel }: IConfirmModalProps) => {
  return (
    <Layer onEsc={onCancel} onClickOutside={onCancel} position="center" margin="large" modal>
      <Box pad="medium" gap="medium">
        <Text>{content}</Text>
        <Box direction="row" align="center" justify="end" gap="small">
          <Button label={confirmLabel || 'Confirm'} onClick={onConfirm} primary />
          <Button label={cancelLabel || 'Cancel'} onClick={onCancel} />
        </Box>
      </Box>
    </Layer>
  );
};
